import { Component, OnInit } from '@angular/core';
import { LIB_PREP_FINISH, ReadBlock, FlowCellBlock, EMPTY_BLOCK_NAME, Lane, LaneBlock, PHIX_BLOCK_NAME, PHIX_COLOR, CalculatePlanDTO, RunPlanDTO, EXCLUSIVE_CONSTRAINT, OVERDUE_BLOCK_NAME, OVERDUE_COLOR, DUELESS_BLOCK_NAME, DUELESS_COLOR, DUEMORE_COLOR, DUEMORE_BLOCK_NAME, REMAINING_LANE_NAME, LibData, RUN_PLANNED } from './models/runPlanConstants';
import { RunPlanningService } from './run-planning.service';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { ConfirmationService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { saveAs as saveByFileSaver } from "file-saver";
import { MasterDataService } from '../masterdata/masterdata.service';

@Component({
  selector: 'app-run-planning',
  templateUrl: './run-planning.component.html',
  styleUrls: ['./run-planning.component.css']
})
export class RunPlanningComponent implements OnInit {

  errorHandler: ErrorHandler = new ErrorHandler;
  sequencerOptions:any[] = [];
  selectedSequencer: string;

  selectedExclusive: string = null;

  selectableLab: any;
  queryResult: any;
  groupData: any;
  ipuCreationData: any;
  totalReads: number = 0;
  onholdReads : number =0;

  sourceReadBlocks: ReadBlock[] = [];
  targetReadBlocks: ReadBlock[] = [];
  selectedBlocks: ReadBlock[] = [];
  backUpBlocks: ReadBlock[] = [];
  colorCodeMap = new Map();
  iconSourceMap = new Map();
  colorRecordMap = new Map();
  iconFlowCellMap= new Map();
  emptyReadBlock: ReadBlock;

  readData: any;
  blocked = false;
  sourceReadEmptyBlock: ReadBlock;
  selectedReads: number=0;
  groupDataSize: number=0;
  flowCellfraction: number;
  flowCellBlocks: FlowCellBlock[] = [];
  flowCellBlock: FlowCellBlock;
  iconFlowCell="fa fa-rocket"
  flowCellList =['MS','MD','ME','2ME','3ME'];
  colours = ['#A52A2A','#5F9EA0','#2E8B57','#2F4F4F','#DAA520','#7CFC00','#191970','#800080','#4169E1','#9ACD32','#FA8072','#ffb3b3', '#9999e6', '#ff80ff', '#a6a6a6', '#ff5050', '#33cccc', '#80ff80', '#ffaa00', '#0099ff', '#888844'];

  // Lane usage variables
  readModeMap = new Map();
  flowCellOptions: any[] = [];
  selectedFlowCell: any;
  lanes: Lane[] = [];
  constraintGroupedList: any[] = [];
  remainingLane: Lane = new Lane();
  resultMap = new Map<string, RunPlanDTO[]>();
  largestReadMode: string;
  puid: string;
  lastRunId: string;

  laneMap = new Map<string, RunPlanDTO>();
  rowDataCheck: boolean = true;
  senderDataCheck: boolean = false;
  exportData = [];
  exportLibraryIds = [];

  constraintTypes: any;
  constriantIds:any;
  selectedConstraintType: any[] = [];
  selectedConstraintID: any[] = [];


  exclusiveOptions:any[] = [];
  constrainIdOptions: any[] = [];

  constraintTypeDropDownMap= new Map<string, any[]>();
 
  constraintIDLibMap= new Map<string, LibData[]>();

  constraintIDDateSortMap=new Map<string, string>();

  constraintIDEarlyDateMap=new Map<string, string[]>();

  constructor(private runPlanningService: RunPlanningService, private _messagesService: MessagesService, private masterDataService: MasterDataService,
    private confirmationService: ConfirmationService,private datepipe: DatePipe) { }

  ngOnInit() {
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.puid = localStorage.getItem('PUID');
    this.iconSourceMap.set('super_fast', 'fa fa-rocket');
    this.iconSourceMap.set('fast', 'fa fa-fighter-jet');
    this.iconSourceMap.set('medium', 'fa fa-ambulance');
    this.iconSourceMap.set('slow', 'fa fa-bicycle');
    this.getSequencerFromMachine();

    this.remainingLane.laneName = REMAINING_LANE_NAME;
    this.remainingLane.laneBlocks = [];
    
    this.runPlanningService.deleteIPUs(this.selectableLab.lab._id).subscribe();
  }

  getDataFromBackEnd(fromRunPlan: boolean) {
    this.sourceReadBlocks = [];
    this.targetReadBlocks = [];
    this.selectedBlocks = [];
    this.flowCellBlocks = [];
    this.backUpBlocks = [];
    this.selectedReads = 0;
    this.totalReads = 0;
    this.onholdReads=0;
    this.selectedConstraintType=[];
    this.selectedConstraintID=[];
    this.constrainIdOptions=[];
    this.exclusiveOptions=[];
    this.constraintIDEarlyDateMap=new Map();
    if(!fromRunPlan)
      this.clearFlowCellAndConstraintDropDowns();
    this.blocked = true;
    this.runPlanningService.getBatchesForLab(this.selectedSequencer, this.selectableLab.lab._id, LIB_PREP_FINISH, this.selectedExclusive).subscribe(
      result => {
        this.blocked = false;
        this.targetReadBlocks.push(this.getEmptyBlock());
        this.sourceReadBlocks.push(this.getEmptyBlockSource());
        this.selectedBlocks.push(this.getEmptyBlock());
        this.colorCodeMap = new Map();
        this.colorRecordMap = new Map();
        this.queryResult = result.data.dataForPlannedread;
        this.onholdReads=result.data.dataForOnHoldread ? result.data.dataForOnHoldread['totalCount']: 0;
        this.initializeGroupingData();
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }

  initializeGroupingData() {
    this.groupData = this.queryResult['groupData'];
    this.totalReads = this.queryResult['totalCount']['totalCount'];

    this.constraintTypes=this.queryResult['constraintTypes'];

    this.constriantIds=this.queryResult['constraintIDs'];

    this.groupDataSize=this.groupData.length;
    this.groupData.forEach(group => {
      let readBlock = new ReadBlock();
      readBlock.name = group['_id'];
      readBlock.libraries = group['libData'];

      readBlock.libraries.forEach(lId=>{
        let libName=lId['libraryId'];
        readBlock.libID.push(libName);
       });

      readBlock.count = group['totalReadCount'];
      readBlock.fraction = ( readBlock.count / this.totalReads );
      readBlock.fraction = readBlock.fraction * 100;
      readBlock.dueDate = new Date(group['dueDate']);
      readBlock.color = this.randomDarkColor(this.groupDataSize);
      readBlock.icon = this.iconSourceMap.get(this.findUrgencyLevel(readBlock.dueDate));
      readBlock.readLength=parseInt(readBlock.name.substring(2,readBlock.name.length));
      this.sourceReadBlocks.push(readBlock);
      this.backUpBlocks.push(readBlock);
      this.colorCodeMap.set(readBlock.name, readBlock.color);
      this.colorRecordMap.set(readBlock.color, "");
    });
    this.readBlockSortingBasedOnNameandLength();
    this.createSortMapForConstraintIDDropDown();
    this.constraintTypeDropDown();
    this.getFlowCellMap();

  }

  randomDarkColor(size:number) {
    let value =  this.colours[size];
    if(this.colorRecordMap.has(value)) {
      return this.randomDarkColor(size);
    } else {
      this.groupDataSize--;
      return value;
    }
  }

  findUrgencyLevel(dueDate: Date)  {
    if(!dueDate) {
      return 'slow'
    } else {
      let differenceInTime = dueDate.getTime() - new Date().getTime();
      let differenceInTImeInDays = differenceInTime / (1000 * 3600 * 24);
      if(differenceInTImeInDays <= 2) {
        return 'super_fast';
      } else if(differenceInTImeInDays > 2 && differenceInTImeInDays <= 5) {
        return 'fast';
      } else if(differenceInTImeInDays > 5 && differenceInTImeInDays <= 8) {
        return 'medium';
      } else {
        return 'slow';
      }
    }
  }

  getStyleOfBlock(readBlock: ReadBlock) {
    return {
      'background-color': readBlock.color,
      'height': readBlock.fraction + '%',
      'border' : '1px solid black'
    }
  }

  getRowStyle(readBlock: ReadBlock) {
    return {
      'background-color': readBlock.color,
      'color': this.getContrastingTextColor(readBlock.color)
    }
  }

  getEmptyBlock() {
    let readBlock = new ReadBlock();
    readBlock.color = 'white';
    readBlock.fraction = 100;
    readBlock.name = EMPTY_BLOCK_NAME;
    this.emptyReadBlock = readBlock;
    return this.emptyReadBlock;
  }

  getEmptyBlockSource() {
    let readBlock = new ReadBlock();
    readBlock.color = 'white';
    readBlock.fraction = 0;
    readBlock.name = EMPTY_BLOCK_NAME;
    this.sourceReadEmptyBlock = readBlock;
    return this.sourceReadEmptyBlock;
  }

  getEmptyFlowCellBlock(){
    let fBlock=new FlowCellBlock();
    fBlock.fraction=100;
    this.flowCellBlock=fBlock;
    return this.flowCellBlock;
  }

  switcherTableRowSelect(_event: any) {
    this.lastRunId= undefined;
    this.switchToLeftAction();

    this.setFlowcellDropDownValue(this.selectedBlocks);
    this.getConstraints();
  }

  switcherTableRowUnselect(event: any) {
    this.backUpBlocks.forEach(backupBlock=>{
      if(event.data.name==backupBlock.name){
        let index = this.selectedBlocks.findIndex(x => x.name === event.data.name);     
           if(index != -1) {
              let block=this.selectedBlocks[index];
              this.selectedReads=this.selectedReads-block.count;
              this.selectedBlocks.splice(index,1);
              let indexSR = this.sourceReadBlocks.findIndex(x => x.name === event.data.name);     
              if(indexSR==-1){
                this.sourceReadBlocks.push(backupBlock);  
              }
           }  
      }
    })
    this.emptyFractionCaluclationLeft();
    this.emptyFractionCaluclationRight();
    
    this.blocked = true;
    this.runPlanningService.deleteIPUs(this.selectableLab.lab._id).subscribe(
      _result => {
        this.blocked = false;
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
    this.setFlowcellDropDownValue(this.targetReadBlocks);
    this.getConstraints()
  }

  getContrastingTextColor(_color: string) {
    return 'white';
  }

  abbreviateNumber(value: number) {
    let newValue = value;
    const suffixes = ["", "K", "M"];
    let suffixNum = 0;
    if(newValue >= 1000000){
      suffixNum = 2;
      while (newValue >= 1000000) {
        newValue /= 1000000;
      }
    } else if(newValue >= 1000){
      suffixNum = 1;
      while (newValue >= 1000) {
        newValue /= 1000;
      }
    }  
    let newValueString = newValue.toFixed(1);
    if(newValueString){
      newValueString = newValueString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    newValueString += suffixes[suffixNum];
    return newValueString;
  }

  deleteIPU() {
    this.runPlanningService.deleteIPUs(this.selectableLab.lab._id).subscribe(
      _result => {
        this.createIPUs();
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }

  createIPUs() {
    let libraryIds = [];
    this.targetBlockLibraryIdExtractor(libraryIds);

    let calculatePlanDTO = new CalculatePlanDTO();
    this.createCalculatePlanDTO(calculatePlanDTO);
    calculatePlanDTO.libraryIds = libraryIds;
    this.blocked = true;
    this.runPlanningService.createIPU(this.selectedSequencer, this.selectableLab.lab._id, "LIB_PREP_FINISH", calculatePlanDTO).subscribe(
      result => {
        this.resultMap = new Map(Object.entries(result.data));
        this.placeOnFlowCell(this.resultMap);
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Flow cell placement Succesful', detail: '' });
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }

  private targetBlockLibraryIdExtractor(libraryIds: any[]) {
    this.selectedBlocks.forEach(read => {
      if (read.name != EMPTY_BLOCK_NAME) {
        read.libID.forEach(library => {
          libraryIds.push(library);
        });
      }
    });
  }

  errorHandlerMethod(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getSequencerFromMachine(){
    this.masterDataService.getConfigList(this.selectableLab.lab._id, "machineType", 0, 100, true).subscribe(
      result => {
        let sequenceData=result.data;
        sequenceData.forEach(seqName => {
          if(seqName.sequencer)
            this.sequencerOptions.push({ label: seqName.name, value: seqName.name });
        });
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }

  getFlowCellMap(){
    this.iconFlowCellMap.clear();
    this.readModeMap.clear();
    this.runPlanningService.getFlowcellCapacity(this.selectableLab.lab._id, this.selectedSequencer).subscribe(
      result => {
        if(result.data) {
          this.iconFlowCellMap = new Map(Object.entries(result.data.flowCellCapacityMap))
          this.readModeMap = new Map(Object.entries(result.data.readModeMap));
          this.caluclateFlowCellBars();
        }
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }

  caluclateFlowCellBars(){
    let flowMesure=this.totalReads;
    this.flowCellBlocks.push(this.getEmptyFlowCellBlock());
    let lastKey:number;
    let lastName:string;
    this.iconFlowCellMap.forEach((value: string, key: string) => {
      let keyNumber: number = +key; 
      if(flowMesure>(keyNumber*1000000)){
      let flowBlock= new FlowCellBlock();
      flowBlock.name=value;
      flowBlock.fraction=((keyNumber*1000000)/this.totalReads);
      flowBlock.fraction= (flowBlock.fraction * 100) - (100 - this.flowCellBlock.fraction);
      this.flowCellBlock.fraction-=flowBlock.fraction;
      flowBlock.icon="fa fa-minus";
      this.flowCellBlocks.push(flowBlock);
      flowMesure=this.totalReads - (keyNumber*1000000);
      lastKey = keyNumber * 1000000;
      lastName= value;
      } 
    })
    let i = 1;
    while(flowMesure>lastKey){
        i++;
        let flowBlock= new FlowCellBlock();
        flowBlock.name=i+"x "+lastName;
        flowBlock.fraction=((i*lastKey)/this.totalReads);
        flowBlock.fraction= (flowBlock.fraction * 100) - (100 - this.flowCellBlock.fraction);
        let result = this.flowCellBlock.fraction - flowBlock.fraction;
        if(result >= 0){
          this.flowCellBlock.fraction-=flowBlock.fraction;
          flowBlock.icon="fa fa-minus";
          this.flowCellBlocks.push(flowBlock); 
        }
        flowMesure =this.totalReads - (lastKey*i);  
    }
    this.flowCellBlocks.reverse();
    this.flowCellBlocks.pop();
    this.flowCellBlocks.unshift(this.flowCellBlock);
  }

  getFlowCellStyle(flowCellBlock:FlowCellBlock){
    return {
      'height': flowCellBlock.fraction+ '%',
      'padding':0
    }
  }

  onExclusiveRowRowUnselect(_event: any){
    this.selectedExclusive='';
    this.selectedReads=0;
    this.getDataFromBackEnd(false);
  }

  setFlowcellDropDownValue(targetBlocks: ReadBlock[]) {
    this.clearFlowCellAndConstraintDropDowns();
    let prefix = 'SR';
    let readLength = 0;
    if(targetBlocks.length > 1) {
      targetBlocks.forEach(block => {
        ({ prefix, readLength } = this.readModeFinder(block, prefix, readLength));
      });
      this.largestReadMode = prefix + ' ' + readLength;
      if(this.readModeMap.get(this.largestReadMode)) {
        this.flowCellOptions = [...this.readModeMap.get(this.largestReadMode)];
        if(this.flowCellOptions.length > 0) {
          this.selectedFlowCell = this.flowCellOptions[0];
          this.constructLanes(this.selectedFlowCell);
        }
      }
    } else{
      this.largestReadMode = '';
    }
  }

  private readModeFinder(block: ReadBlock, prefix: string, readLength: number) {
    if (block.name != EMPTY_BLOCK_NAME) {
      let parts = block.name.split(" ");
      if (parts[0] && parts[0] == 'PE') {
        prefix = 'PE';
      }
      let part = Number(parts[1]);
      if (part > readLength) {
        readLength = part;
      }
    }
    return { prefix, readLength };
  }

  comparator(val1: any, val2: any) {
    if(val1 > val2) {
      return 1;
    } else if(val2 > val1) {
      return -1;
    } else {
      return 0;
    }
  }

  clearFlowCellAndConstraintDropDowns() {
    this.flowCellOptions = [];
    this.selectedFlowCell = null;
    this.lanes = [];
  }

  constructLanes(selectedFlowCell: any) {
    this.lanes = [];
    this.remainingLane = new Lane();
    this.resultMap = new Map();
    let laneBlock = new LaneBlock();
    laneBlock.name = PHIX_BLOCK_NAME;
    laneBlock.color = PHIX_COLOR;
    laneBlock.weightPercentage = 1;
    for(let i = 1; i <= selectedFlowCell.logicalLanes; i++) {
      let lane = new Lane();
      lane.laneName = "Lane " + i;
      lane.constraintIdChooser = 'no';
      lane.totalCapacity = this.selectedFlowCell.laneCapacity * 1000000;
      laneBlock.weight = lane.totalCapacity * (laneBlock.weightPercentage / 100);
      lane.occupiedCapacity = laneBlock.weight;
      lane.phiXPercentage = laneBlock.weightPercentage;
      lane.occupiedPercentage =  laneBlock.weightPercentage;
      lane.laneBlocks.push(Object.assign({}, laneBlock));
      this.lanes.push(lane);
    }
  }

  changePhixBlockInLane(lane: Lane) {
    if(isNaN(lane.phiXPercentage)) {
      lane.phiXPercentage = 0;
    } else if(lane.phiXPercentage < 0) {
      lane.phiXPercentage = 0;
    } else if(lane.phiXPercentage > 100) {
      lane.phiXPercentage = 100;
    }

    if(this.resultMap && this.resultMap.size > 0) {
      this.clearLanes();
    }
    lane.laneBlocks[0].weightPercentage = lane.phiXPercentage;
    lane.laneBlocks[0].weight = lane.totalCapacity * (lane.phiXPercentage / 100);
    lane.occupiedCapacity = 0;
    lane.laneBlocks.forEach(block => {
      lane.occupiedCapacity += block.weight;
    });
    lane.occupiedPercentage = Math.round(((lane.occupiedCapacity / lane.totalCapacity) * 100) * 100) / 100;
  }

  getLaneBlockStyle(laneBlock: LaneBlock) {
    return {
      'width': laneBlock.weightPercentage + '%',
      'background-color': laneBlock.color,
      'border' : (laneBlock.weightPercentage > 0) ? '1px solid black' : 'none'
    }
  }

  getConstraints() {
    let libraryIds = [];
    this.targetBlockLibraryIdExtractor(libraryIds);

    this.runPlanningService.getConstraintInfo(this.selectableLab.lab._id, libraryIds).subscribe(
      result => {
        if(result.data) {
          this.constructConstraintDropDownGrouping(result.data);
        } else {
          this.constructConstraintDropDownGrouping([]);
        }
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }

  constructConstraintDropDownGrouping(data: any[]) {
    this.constraintGroupedList = [
      {
        label: 'No', value: 'No',
        items: [
          {label:'no', value:'no'}
        ]
      }
    ];
    data.forEach(group => {
      let groupValue  = {
        label: group._id, value: group._id,
        items: []
      };
      group.output.forEach(element => {
        groupValue.items.push({label:element, value:element + '##' + group._id})
      });
      this.constraintGroupedList.push(groupValue);
    });
  }

  assignConstraintIdAndType(event: any, lane: Lane) {
    this.lastRunId= undefined;
    if(this.resultMap && this.resultMap.size > 0) {
      this.clearLanes();
    }
    if(event.value == 'no') {
      lane.constraintId = 'no';
      lane.constraintType = 'no';
    } else {
      let value = event.value.split("##");
      lane.constraintId = value[0];
      lane.constraintType = value[1];
    }
  }

  createCalculatePlanDTO(calculatePlanDTO: CalculatePlanDTO) {
    let runPlanDTOMap = new Map<string, RunPlanDTO[]>();
    this.lanes.forEach(lane => {
      calculatePlanDTO.laneInfos.push(lane.laneName);
      if(lane.constraintId == 'no') {
        calculatePlanDTO.noConstraint = true;
      } else {
        calculatePlanDTO.constraintIds.push(lane.constraintId);
      }
      if(!runPlanDTOMap.has(lane.constraintId)) {
        let runPlanDTOList = [];
        let runPlanDTO = new RunPlanDTO();
        runPlanDTO.laneInfo = lane.laneName;
        runPlanDTO.phiXPercentage = lane.phiXPercentage;
        runPlanDTO.occupiedCapacity = lane.occupiedCapacity;
        runPlanDTO.occupiedPercentage = lane.occupiedPercentage;
        runPlanDTO.laneCapacity = lane.totalCapacity;
        runPlanDTO.constratintType = lane.constraintType;
        runPlanDTO.constraintId = lane.constraintId;
        runPlanDTO.calculatedValue = lane.totalCapacity - lane.laneBlocks[0].weight;
        runPlanDTOList.push(runPlanDTO);
        runPlanDTOMap.set(lane.constraintId, runPlanDTOList);
      } else {
        let runPlanDTOList = runPlanDTOMap.get(lane.constraintId);
        let runPlanDTO = new RunPlanDTO();
        runPlanDTO.laneInfo = lane.laneName;
        runPlanDTO.laneCapacity = lane.totalCapacity;
        runPlanDTO.phiXPercentage = lane.phiXPercentage;
        runPlanDTO.occupiedCapacity = lane.occupiedCapacity;
        runPlanDTO.occupiedPercentage = lane.occupiedPercentage;
        runPlanDTO.constratintType = lane.constraintType;
        runPlanDTO.constraintId = lane.constraintId;
        runPlanDTO.calculatedValue = lane.totalCapacity - lane.laneBlocks[0].weight;
        runPlanDTOList.push(runPlanDTO);
        runPlanDTOMap.set(lane.constraintId, runPlanDTOList);
      }
    });
    calculatePlanDTO.sequencerType = this.selectedSequencer;
    calculatePlanDTO.labId = this.selectableLab.lab._id;
    calculatePlanDTO.status = "LIB_PREP_FINISH";
    calculatePlanDTO.runPlanDTOMap = this.getObjectFromMap(runPlanDTOMap);
  }

  isCalculateDisabled() {
    let disabled = false;
    if(!this.targetReadBlocks || this.targetReadBlocks.length < 2) {
      disabled = true;
    }

    if(!this.selectedFlowCell) {
      disabled = true;
    }

    this.lanes.forEach(lane => {
      if(!lane.constraintId) {
        disabled = true;
      } 
    });
    return disabled;
  }

  placeOnFlowCell(resultMap: Map<string, RunPlanDTO[]>) {
    let exclsuiveValue = resultMap.get(EXCLUSIVE_CONSTRAINT);
    if(exclsuiveValue && exclsuiveValue.length > 0) {
      this.showPopUp(exclsuiveValue);
    } else {
      this.lanePlacement();
    }
  }

  isFlowCellSelectionDisabled() {
    return !(this.flowCellOptions && this.flowCellOptions.length > 0);
  }

  getRemainingCapacity() {
    if(this.resultMap && this.resultMap.size > 0) {
      return this.abbreviateNumber(this.remainingLane.occupiedCapacity);
    } else {
      return '';
    }
  }

  getRemainingPercentage() {
    if(this.resultMap && this.resultMap.size > 0) {
      return this.remainingLane.occupiedPercentage + ' %';
    } else {
      return '';
    }
  }

  getObjectFromMap(runPlanDTOMap: Map<string, RunPlanDTO[]>) {
    let jsonObj = {};

    runPlanDTOMap.forEach((value, key) => {
      jsonObj[key] = value;
    });

    return jsonObj;
  }

  showPopUp(exclsuiveValue: any[]) {
    let exclusiveReadCount = 0;
    exclsuiveValue.forEach(ex => {
      exclusiveReadCount += ex.weight ;
    });

    this.confirmationService.confirm({
      message: 'Exclusive reads found for the constraint id are ' + exclusiveReadCount +', exceed the lane capacity. Are you sure you want to continue placement?',
      header: 'Confirmation',
      accept: () => {
        this.lanePlacement();
      },
      reject: () => {
        this.resultMap = new Map();
      }
    });
  }

  lanePlacement() {
    this.lanes.forEach(lane => {
      let laneDTO = new RunPlanDTO();
      let phiXLane = lane.laneBlocks[0];
      let ipus = this.resultMap.get(lane.laneName);
      
      let overDueLaneBlock = new LaneBlock();
      overDueLaneBlock.name = OVERDUE_BLOCK_NAME;
      overDueLaneBlock.color = OVERDUE_COLOR;
      
      let dueLessLaneBlock = new LaneBlock();
      dueLessLaneBlock.name = DUELESS_BLOCK_NAME;
      dueLessLaneBlock.color = DUELESS_COLOR;
      
      let dueMoreLaneBlock = new LaneBlock();
      dueMoreLaneBlock.name = DUEMORE_BLOCK_NAME;
      dueMoreLaneBlock.color = DUEMORE_COLOR;

      lane.laneBlocks = [];
      lane.laneBlocks.push(phiXLane);
      lane.phiXPercentage = phiXLane.weightPercentage;
      lane.occupiedCapacity = phiXLane.weight;
      if(ipus) {
        ipus.forEach(ipu => {
          if(ipu.dueDate < 2) {
            overDueLaneBlock.weight += ipu.weight;
            overDueLaneBlock.ipus.push(ipu);
          } else if(ipu.dueDate >= 2 && ipu.dueDate <= 5) {
            dueLessLaneBlock.weight += ipu.weight;
            dueLessLaneBlock.ipus.push(ipu);
          } else {
            dueMoreLaneBlock.weight += ipu.weight;
            dueMoreLaneBlock.ipus.push(ipu);
          }
        });

        
        this.lanePlacer(overDueLaneBlock, lane, dueLessLaneBlock, dueMoreLaneBlock);
        
        lane.occupiedPercentage =  Math.round(((lane.occupiedCapacity / lane.totalCapacity) * 100) * 100) / 100;
        laneDTO.phiXPercentage = lane.phiXPercentage;
        laneDTO.occupiedCapacity = lane.occupiedCapacity;
        laneDTO.occupiedPercentage = lane.occupiedPercentage;
        this.laneMap.set(lane.laneName, laneDTO);
      }
    });

    this.placeOnRemainingLane();
  }

  private lanePlacer(overDueLaneBlock: LaneBlock, lane: Lane, dueLessLaneBlock: LaneBlock, dueMoreLaneBlock: LaneBlock) {
    if (overDueLaneBlock.weight > 0) {
      overDueLaneBlock.weightPercentage = Math.round(((overDueLaneBlock.weight / lane.totalCapacity) * 100) * 10) / 10;
      lane.laneBlocks.push(overDueLaneBlock);
      lane.occupiedCapacity += overDueLaneBlock.weight;
    }

    if (dueLessLaneBlock.weight > 0) {
      dueLessLaneBlock.weightPercentage = Math.round(((dueLessLaneBlock.weight / lane.totalCapacity) * 100) * 10) / 10;
      lane.laneBlocks.push(dueLessLaneBlock);
      lane.occupiedCapacity += dueLessLaneBlock.weight;
    }

    if (dueMoreLaneBlock.weight > 0) {
      dueMoreLaneBlock.weightPercentage = Math.round(((dueMoreLaneBlock.weight / lane.totalCapacity) * 100) * 10) / 10;
      lane.laneBlocks.push(dueMoreLaneBlock);
      lane.occupiedCapacity += dueMoreLaneBlock.weight;
    }
  }

  placeOnRemainingLane() {
    let laneDTO = new RunPlanDTO();
    let laneCapacity = this.selectedFlowCell.laneCapacity * 1000000;
    this.remainingLane = new Lane();
    this.remainingLane.laneName = REMAINING_LANE_NAME;
    let remainingIpus = this.resultMap.get(this.remainingLane.laneName);
    
    let overDueLaneBlock = new LaneBlock();
    overDueLaneBlock.name = OVERDUE_BLOCK_NAME;
    overDueLaneBlock.color = OVERDUE_COLOR;

    let dueLessLaneBlock = new LaneBlock();
    dueLessLaneBlock.name = DUELESS_BLOCK_NAME;
    dueLessLaneBlock.color = DUELESS_COLOR;

    let dueMoreLaneBlock = new LaneBlock();
    dueMoreLaneBlock.name = DUEMORE_BLOCK_NAME;
    dueMoreLaneBlock.color = DUEMORE_COLOR;

    if(remainingIpus) {
      let totaIPUlWeight = 0;
      remainingIpus.forEach(ipu => {
        if(ipu.dueDate < 2) {
          overDueLaneBlock.weight += ipu.weight;
          overDueLaneBlock.ipus.push(ipu);
        } else if(ipu.dueDate >= 2 && ipu.dueDate <= 5) {
          dueLessLaneBlock.weight += ipu.weight;
          dueLessLaneBlock.ipus.push(ipu);
        } else {
          dueMoreLaneBlock.weight += ipu.weight;
          dueMoreLaneBlock.ipus.push(ipu);
        }
        totaIPUlWeight += ipu.weight;
      });

      if(totaIPUlWeight > laneCapacity) {
        this.remainingLane.totalCapacity = totaIPUlWeight;
      } else {
        this.remainingLane.totalCapacity = laneCapacity;
      }
      this.lanePlacer(overDueLaneBlock, this.remainingLane, dueLessLaneBlock, dueMoreLaneBlock);

      this.remainingLane.occupiedPercentage =  Math.round(((this.remainingLane.occupiedCapacity / laneCapacity) * 100) * 100) / 100;
      laneDTO.occupiedCapacity = this.remainingLane.occupiedCapacity;
      laneDTO.occupiedPercentage = this.remainingLane.occupiedPercentage;
      this.laneMap.set(this.remainingLane.laneName, laneDTO);
    }
  }


  getRemainingNumberStyle() {
    if(this.remainingLane.occupiedPercentage > 100) {
      return {
        'color' : 'red'
      }
    }
  }

  clearLanes() {
    this.remainingLane = new Lane();
    this.lastRunId= undefined;
    this.remainingLane.laneName = REMAINING_LANE_NAME;
    this.resultMap = new Map();
    this.lanes.forEach(lane => {
      lane.laneBlocks.length = 1;
      lane.occupiedCapacity = lane.laneBlocks[0].weight;
      lane.occupiedPercentage = lane.phiXPercentage;
    });
  }

  disablePublishRun(){
      return (Array.from(this.resultMap.keys()).length == 0 || this.lastRunId);
  }

  disableExportRun(){
    return Array.from(this.resultMap.keys()).length == 0;
  }

  publishRun(){
    let run = {};
    run['lab'] = this.selectableLab.lab._id;
    run['sequencerType'] = this.selectedSequencer;
    run['flowCellName'] = this.selectedFlowCell.flowCellName;
    run['flowCellType'] = this.selectedFlowCell.flowCellType;
    run['flowCellMode'] = this.selectedFlowCell.flowCellMode;
    run['largestReadMode'] = this.largestReadMode;
    run['runPlannedPuid'] = this.puid;
    run['status'] = RUN_PLANNED;
    let runLanes = [];
    let libraryIds = [];
    let libLaneMap = {};
    let totalPoolReads = 0;
    this.resultMap.forEach((value: RunPlanDTO[], key: string) => {
      if (key != REMAINING_LANE_NAME) {
        let laneId = key.charAt(key.length - 1);
        let eachLane = {};
        eachLane['laneId'] = key;
        eachLane['runLanes'] = value;
        runLanes.push(eachLane);
        value.forEach(laneBlock => {
          laneBlock.libraryId.forEach(lib =>{
            libLaneMap[lib] = laneId;
            libraryIds.push(lib)
          })
          totalPoolReads += laneBlock.weight
        });
      }
    })
    run['plannedReadsPoolLibs'] = totalPoolReads;
    run['runLanes'] = runLanes;
    run['libraryIds'] = libraryIds;
    run['libLaneMap'] = libLaneMap;
    this.blocked=true;
    this.runPlanningService.publishRunPlan(run).subscribe(
      result=>{
        this._messagesService.addSuccessMessage({
          severity: 'success', summary:"Successfully Published Run!",
          detail:'Run ID: ' + result.data
        })
        this.lastRunId = result.data;
        this.getDataFromBackEnd(true);
        this.blocked = false
      },
      error=>{
        this.errorHandlerMethod(error);
      }

    )
  }

  discardPlan(){
    this.clearLanes()
    this.runPlanningService.deleteIPUs(this.selectableLab.lab._id).subscribe();
    this.lanes.forEach(lane=>{
      lane.laneBlocks[0].weightPercentage = lane.phiXPercentage;
      lane.laneBlocks[0].weight = lane.totalCapacity * (lane.phiXPercentage / 100);
      lane.occupiedCapacity = 0;
      lane.laneBlocks.forEach(block => {
        lane.occupiedCapacity += block.weight;
      });
      lane.occupiedPercentage = Math.round(((lane.occupiedCapacity / lane.totalCapacity) * 100) * 100) / 100;
    })
  }

  equiliseLanes(){
    let requestObj = {};
    let resultMapObj = {};
    let constraintIdLaneMap = {};
    let laneInfoMap = {};

    this.lanes.forEach(lane=>{
      if(this.resultMap.has(lane.laneName))
        resultMapObj[lane.laneName]=this.resultMap.get(lane.laneName)
      else
        resultMapObj[lane.laneName]=[]
      let totalWeight = lane.occupiedCapacity;
      let constraintIdLaneMapValue = {};
      let laneInfoValue = {};
      let epsilon = 0;
      let sortedIpus = [];
      let tagDependencies = [];
      let lanes = []
      if(!constraintIdLaneMap[lane.constraintId]){
        lanes = [lane.laneName]
      } else{

        constraintIdLaneMapValue = constraintIdLaneMap[lane.constraintId];
        lanes = constraintIdLaneMapValue['lanes'];
        lanes.push(lane.laneName)
        epsilon = constraintIdLaneMapValue['epsilon']
      }

      let ipus = this.resultMap.get(lane.laneName);
      if(ipus != null && ipus.length > 0){
        epsilon = ipus[0].weight;
        ipus.forEach(ipu =>{
          if(epsilon > ipu.weight)
            epsilon = ipu.weight;
          tagDependencies =  tagDependencies.concat(ipu.tagDependencyList);
        })
        sortedIpus = [...ipus];
        this.sortIPUsBasedOnWeight(sortedIpus)
      } 
      constraintIdLaneMapValue['lanes'] = lanes;
      constraintIdLaneMapValue['epsilon']=epsilon;
      constraintIdLaneMap[lane.constraintId] = constraintIdLaneMapValue;

      laneInfoValue['weight'] = totalWeight;
      laneInfoValue['sortedIPUs'] = sortedIpus;
      laneInfoValue['tagDependencies'] = tagDependencies;
      laneInfoMap[lane.laneName] = laneInfoValue

    })
    resultMapObj[REMAINING_LANE_NAME] = this.resultMap.get(REMAINING_LANE_NAME)
    requestObj['runPlanMap'] = resultMapObj;
    requestObj['constraintIdLaneMap'] = constraintIdLaneMap;
    requestObj['laneInfoMap'] = laneInfoMap;
    requestObj['totalCapacity'] = this.selectedFlowCell.laneCapacity * 1000000;
    this.blocked = true
    this.runPlanningService.balanceLanes(requestObj).subscribe(
      result=>{
        this.resultMap = new Map(Object.entries(result.data));
        this.placeOnFlowCell(this.resultMap);
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Lane Balancing Successful', detail: '' });
      },
      error => {
        this.errorHandlerMethod(error);
      }
    )
  }
  sortIPUsBasedOnWeight(ipus: RunPlanDTO[]) {
    ipus.sort((d1, d2) => {
      if (d1.weight < d2.weight)
        return -1;
      else if (d1.weight > d2.weight)
        return 1;

      else
        return 0;
    });
  }
  

  constraintTypeDropDown(){
    this.constriantIds.forEach(constrianType=>{
      let name=constrianType['_id'];
      let constIds=constrianType['ConstIDs'];
      this.constraintTypeDropDownMap.set(name,constIds);
      this.exclusiveOptions.push({ label: name, value: name });
      this.selectedConstraintType.push(name);
    });

    this.selectedConstraintType.forEach(selectedCtype=>{
      this.ConstrainIDSelectionDropDown(selectedCtype);
    })

  }

  ConstrainIDSelectionDropDown(selectdConstTYpe){
    let values=this.constraintTypeDropDownMap.get(selectdConstTYpe);
    values.forEach(value=>{
      let v1=value;
      if(selectdConstTYpe=='independent' && value==""){
        v1='independent';
      }
      let dateValue=this.sortBasedonEarlyDate(value);
      this.constrainIdOptions.push({label: v1 +",\t" +dateValue, value: value })
    })
  }

  ConstrainIDRemoveDropDown(selectdConstTYpe){
      
    let values=this.constraintTypeDropDownMap.get(selectdConstTYpe);
      values.forEach(value=>{
        let index=this.constrainIdOptions.findIndex(x=>x.value==value);
        if(index!=-1){
          this.constrainIdOptions.splice(index,1);
        }
        let index1=this.selectedConstraintID.findIndex(data=>data==value);
        if(index1!=-1){
          this.selectedConstraintID.splice(index1,1);
        }
      })
  }
  
  onExclusiveRowSelect(event: any){  
    if(event.value.includes(event.itemValue)){
      this.ConstrainIDSelectionDropDown(event.itemValue);
      this.switchToLeftAction();
      this.setFlowcellDropDownValue(this.selectedBlocks);
      this.getConstraints();
    }else{
      let data=this.constraintTypeDropDownMap.get(event.itemValue);
      this.ConstrainIDRemoveDropDown(event.itemValue);
      if(!this.selectedConstraintID.includes(data)){
         this.switchFromRightToLeftCTypeCID(data);
      }
      this.setFlowcellDropDownValue(this.selectedBlocks);
      this.getConstraints();
    }
  }

  onConstraintID(event: any){
    if(event.value.includes(event.itemValue)){
      this.switchToLeftAction();
      this.setFlowcellDropDownValue(this.selectedBlocks);
      this.getConstraints();
    }else{
      let arr=[]
      arr.push(event.itemValue)
      this.switchFromRightToLeftCTypeCID(arr);
      this.setFlowcellDropDownValue(this.selectedBlocks);
      this.getConstraints();
    }
  }

  switchToLeftAction(){    
    this.readData=this.queryResult['readData'];
    let selectedReadsValue=0
    if(this.targetReadBlocks.length>0){
      this.targetReadBlocks.forEach(sbBlock=>{
        if(this.readData[sbBlock.name]!=undefined){
          let ctype=this.readData[sbBlock.name];
          let selectBlock=new ReadBlock();
          let missingReads=0;
              if(this.selectedConstraintType.length>0){
               
                this.selectedConstraintType.forEach(selectedCstType=>{
            
                  if(ctype[selectedCstType]!=undefined){
                    
                    let selectedConstTypeObj=ctype[selectedCstType];
               
                    if(this.selectedConstraintID.length>0){
                        
                      this.selectedConstraintID.forEach(selectedConstID=>{
                      
                        if(selectedConstTypeObj[selectedConstID]!=undefined){
                          
                          let selectedConstIDObj=selectedConstTypeObj[selectedConstID];
                      
                          this.constraintIDLibMap.set(selectedConstID+sbBlock.name,selectedConstIDObj)
                         
                          selectedConstIDObj.forEach(libDataOfselectedCID=>{
                                  selectBlock.name=sbBlock.name;
                                  selectBlock.color=sbBlock.color;
                                  this.constraintIDDateSortMap.set(libDataOfselectedCID.libraryId,libDataOfselectedCID.dueDate);
                                  missingReads+=libDataOfselectedCID.missingReads;
                                  selectBlock.count=missingReads;
                                  selectBlock.libID.push(libDataOfselectedCID.libraryId);
                                  selectBlock.dueDate=this.findMinimumDueDate(new Date(libDataOfselectedCID.dueDate),selectBlock);
                                  selectBlock.icon= this.iconSourceMap.get(this.findUrgencyLevel(selectBlock.dueDate));
                                  selectBlock.fraction=( missingReads / this.totalReads )
                                  selectBlock.fraction = selectBlock.fraction * 100;
                            });
                            }
                          });
                      
                      }

                    }

                });
              }

          //creating the full or partial blocks once all 3 checks done 
          selectedReadsValue=selectedReadsValue+missingReads;
          let indexofSelectedBlock = this.selectedBlocks.findIndex(x => x.name === selectBlock.name);
          if(indexofSelectedBlock != -1) { 
             this.selectedBlocks.splice(indexofSelectedBlock,1);
             this.selectedBlocks.push(selectBlock);
           }else{
             if(selectBlock.fraction>0){
              this.selectedBlocks.push(selectBlock)
             }
           } 
           
          // Removing the source block based on matching lib IDs 
          this.sourceReadBlocks.forEach(sourceReadBlockObj=>{
            let indexOfSourceBlock = this.sourceReadBlocks.findIndex(x => x.name === selectBlock.name);
            if(indexOfSourceBlock != -1) {
              if(selectBlock.name==sourceReadBlockObj.name && selectBlock.libID.length==sourceReadBlockObj.libID.length){
                this.sourceReadEmptyBlock.fraction+=selectBlock.fraction;
                this.sourceReadBlocks.splice(indexOfSourceBlock,1);
                }
              }
          });

         }
      });
    }

    this.selectedReads=selectedReadsValue;
    let emptyFraction=0;
    if(this.selectedBlocks.length>1){
      this.selectedBlocks.splice(0,1);
      this.selectedBlocks.forEach(sbBlockForEmptyCal=>{
        emptyFraction+=sbBlockForEmptyCal.fraction;
      });
    this.selectedBlocks.splice(0,0,this.getEmptyBlock())
    this.emptyReadBlock.fraction-=emptyFraction  
    }
    this.selectedBlocks.reverse();
    this.selectedBlocks.pop();
    if(this.emptyReadBlock.fraction < 0) {
      this.emptyReadBlock.fraction = 0;
    }
    this.selectedBlocks.unshift(this.emptyReadBlock);
  }



  switchFromRightToLeftCTypeCID(constList:string[]){
    let selectedReadsValue=0;
    constList.forEach(sID=>{
      this.selectedBlocks.forEach(selectedBlock=>{
        if(this.constraintIDLibMap.get(sID+selectedBlock.name)!=undefined){
          let libDatBasedOnCID=this.constraintIDLibMap.get(sID+selectedBlock.name)
          let missingReads=0;
          libDatBasedOnCID.forEach(libDataOfSwitchLeft=>{
              let fraction=(libDataOfSwitchLeft.missingReads / this.totalReads )
              missingReads+=libDataOfSwitchLeft.missingReads;
              selectedReadsValue=missingReads;
              selectedBlock.count-=libDataOfSwitchLeft.missingReads;
              fraction = fraction * 100;
              const index = selectedBlock.libID.indexOf(libDataOfSwitchLeft.libraryId);
               if(index!=-1){
                selectedBlock.libID.splice(index,1);
               }
              selectedBlock.fraction-=fraction;
          })

          // find the frequnency level with the available libData information
          selectedBlock.libID.forEach(libID=>{
            selectedBlock.dueDate=this.findMinimumDueDate(new Date(this.constraintIDDateSortMap.get(libID)),selectedBlock);
            selectedBlock.icon= this.iconSourceMap.get(this.findUrgencyLevel(selectedBlock.dueDate));
          })

          this.selectedReads=this.selectedReads-selectedReadsValue;
          
          this.backUpBlocks.forEach(backupBlock=>{
            let indexSR = this.sourceReadBlocks.findIndex(x => x.name === backupBlock.name);   
            if(selectedBlock.name==backupBlock.name){ 
              if(indexSR==-1){
                this.sourceReadBlocks.push(backupBlock);  
              }
            }
          })

        }
      });
    });

    let fractionforSelectedBlock=0;
    for (var i = this.selectedBlocks.length - 1; i >= 0; i--) {
          if(this.selectedBlocks[i].libID.length<=0 && this.selectedBlocks[i].name!=EMPTY_BLOCK_NAME){
            fractionforSelectedBlock+=this.selectedBlocks[i].fraction;
            this.selectedBlocks.splice(i,1);
          }
    }

    this.emptyFractionCaluclationLeft();
    this.emptyFractionCaluclationRight();
  }

  emptyFractionCaluclationLeft(){
    let fraction=0;
    this.selectedBlocks.forEach(sbBlockOfLeft=>{
      if(sbBlockOfLeft.name!=EMPTY_BLOCK_NAME){
       fraction+=sbBlockOfLeft.fraction;
      }
    })
    this.emptyReadBlock.fraction=100;
    this.emptyReadBlock.fraction-=fraction;
    if(this.emptyReadBlock.fraction<0){
      this.emptyReadBlock.fraction=0;
    }

  }
  
  emptyFractionCaluclationRight(){
    let fraction=0;
    this.sourceReadBlocks.forEach(sbBlockOfRight=>{
      if(sbBlockOfRight.name!=EMPTY_BLOCK_NAME){
       fraction+=sbBlockOfRight.fraction;
      }
    })
    this.sourceReadEmptyBlock.fraction=100;
    this.sourceReadEmptyBlock.fraction-=fraction;
    if(this.sourceReadEmptyBlock.fraction<0){
      this.sourceReadEmptyBlock.fraction=0;
    }
  }
 
  findMinimumDueDate(dueDate:Date,selectedBlock:ReadBlock){
    if(selectedBlock.dueDate!=undefined && selectedBlock.dueDate!=null){
      if(selectedBlock.libID.length>1){
        if(dueDate.getTime()<selectedBlock.dueDate.getTime()){
          return dueDate;
        }else{
          return selectedBlock.dueDate;
        }
      }else{
        return dueDate;
      }
    }else{
      return dueDate;
    }
   
  }

  createSortMapForConstraintIDDropDown(){
    this.groupData.forEach(grpData=>{
      grpData['libData'].forEach(libArrData=>{
        let constType=libArrData['constraintId'];
        let constDate=libArrData['dueDate'];
        if(this.constraintIDEarlyDateMap.get(constType)!=undefined){
          let arrDate=this.constraintIDEarlyDateMap.get(constType);
          arrDate.push(constDate);
          this.constraintIDEarlyDateMap.set(constType,arrDate);
        }else{
          let arr=[];
          arr.push(constDate);
          this.constraintIDEarlyDateMap.set(constType,arr);
        }
      });
  
    });
  }


  sortBasedonEarlyDate(value:string){
    let dateValues=this.constraintIDEarlyDateMap.get(value);
    dateValues.sort((x, y) => +new Date(x) - +new Date(y));
    return this.datepipe.transform(new Date(dateValues[0]), 'yyyy-MM-dd');
  }

  readBlockSortingBasedOnNameandLength(){
    
    let PBlocks=this.backUpBlocks.filter(pblock=>pblock.name.includes("PE"));
    let sBlocks=this.backUpBlocks.filter(pblock=>pblock.name.includes("SR"));
    
    PBlocks.sort(
      (a, b) => (a.readLength < b.readLength ? 1 : -1))
  
    sBlocks.sort(
        (a, b) => (a.readLength < b.readLength ? 1 : -1))
   
    this.backUpBlocks=[];
    PBlocks.forEach(PblockObj=>{
      this.backUpBlocks.push(PblockObj);
    })
   
    sBlocks.forEach(sbBlockObj=>{
      this.backUpBlocks.push(sbBlockObj);
    })

  }

  exportObj(runObj) {
    runObj.libraryId.forEach(libID => {
      this.exportLibraryIds.push(libID);
      let obj = {
        "flowcell": this.selectedFlowCell.flowCellName,

        "readMode": this.largestReadMode,

        "laneId": runObj.laneInfo === "remaining" ? '0' : runObj.laneInfo,

        "percentPhiX": runObj.laneInfo === "remaining" ? 0 : this.laneMap.get(runObj.laneInfo).phiXPercentage,

        "constraintId": runObj.constraintId,

        "constratintType": "",

        "libraryID": libID,

        "projectName": "",

        "sampleName": "",

        "status": "",

        "singleOnPairedMode": "",

        "readLength": "",

        "missingReads": "",

        "rawDataDueDate": "",

        "highPriorty": "",

        "tagName": "",

        "tagSequence": "",

        "laneSumOfReads": this.laneMap.get(runObj.laneInfo).occupiedCapacity === undefined ? '0' : this.laneMap.get(runObj.laneInfo).occupiedCapacity,

        "laneFillLevel": this.laneMap.get(runObj.laneInfo).occupiedPercentage === undefined || this.laneMap.get(runObj.laneInfo).occupiedPercentage === Infinity ? 'Infinity' : this.laneMap.get(runObj.laneInfo).occupiedPercentage

      };

      this.exportData.push(obj);

    })
  }
  exportWarningMessage() {
    if (!this.rowDataCheck && !this.senderDataCheck) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Export Option Not Selected', detail: 'Please select at least one export option.' });
    }
  }
  exportDetails(element) {
    element.forEach(runObj => {
      this.exportObj(runObj);
    })
  }
  exportPlan() {
    this.exportWarningMessage();

    this.exportData = [];
    this.exportLibraryIds = [];
    if (this.resultMap) {
      Array.from(this.resultMap.values()).forEach(element => {
        this.exportDetails(element);
      });

    }
    let today = new Date();
    let dateString = this.datepipe.transform(today, 'yyyy-MM-dd_HH-mm');
    var runIdVal = this.lastRunId === undefined ? "new" : this.lastRunId;
    let dataToExport = { "libraryIds": this.exportLibraryIds, "labId": this.selectableLab.lab._id, "runId": runIdVal, "exportedDateTime": dateString, "sequencerType": this.selectedSequencer, "runPlanDTOs": this.exportData };
    this.blocked =  true;
    this.runPlanningService.exportRunPlan(dataToExport).subscribe(
      result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Excel downloaded successfully',
          detail: '',
        });
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        saveByFileSaver(blob, dateString + '_' + this.selectedSequencer + '_RunPlan_' + runIdVal + ".xlsx");
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Download Failed!!',
          detail: 'Error occured while exporting data to excel.... Please refresh & try again!'
        })
      }

    )
  }

}
